// src/components/Layout.jsx
import React, {useEffect} from 'react';
import Navbar from './NavBar.jsx';
import Footer from './Footer.jsx';
import { Outlet, useLocation } from 'react-router-dom';

const Layout = ({ children }) => {

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen radial-gradient">
      <Navbar />
      <Outlet />  {/* This renders the current page content */}
      <Footer />
    </div>
  );
};

export default Layout;